import { supabase } from '@/lib/supabase-unified'
import type { LessonVideo, UserLessonVideoInteraction } from '@/types'

export type LessonVideosWithProgressData = {
  videos: LessonVideo[]
  user_videos: UserLessonVideoInteraction[]
}

export async function fetchLessonVideosWithProgress(input: {
  lessonId: number
  userId: string | null
}): Promise<LessonVideosWithProgressData> {
  const { data, error } = await supabase.rpc('get_lesson_videos_with_progress', {
    p_lesson_id: input.lessonId,
    p_user_id: input.userId ?? null,
  })

  if (error) {
    throw new Error(`Supabase Error: ${error.message}`)
  }

  return data as LessonVideosWithProgressData
}

